import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from "react";
import { Aria, Styles } from "react-modal";
import { useWindowSize } from "usehooks-ts";
import { breakpoints } from "@ops-gsic/cxp-component-library-react";
import { StyledModal } from "./styles";
interface AppModalProps {
  modalIsOpen: boolean;
  closeModal?: () => void;
  children: React.ReactNode;
  shouldCloseOnEsc?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  customStyles?: Styles;
  customAria?: Aria;
  className?: string;
  contentName?: string;
}
const AppModal = t0 => {
  const $ = _c(12);
  const {
    modalIsOpen,
    closeModal,
    children,
    shouldCloseOnEsc,
    shouldCloseOnOverlayClick,
    customStyles,
    customAria,
    className,
    contentName
  } = t0;
  const {
    width: windowWidth
  } = useWindowSize();
  const isMobileSizeScreen = windowWidth < breakpoints.small;
  let t1;
  if ($[0] !== closeModal) {
    t1 = () => {
      if (closeModal) {
        closeModal();
      }
    };
    $[0] = closeModal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onCloseModal = t1;
  const t2 = isMobileSizeScreen ? undefined : customStyles;
  let t3;
  if ($[2] !== children || $[3] !== className || $[4] !== contentName || $[5] !== customAria || $[6] !== modalIsOpen || $[7] !== onCloseModal || $[8] !== shouldCloseOnEsc || $[9] !== shouldCloseOnOverlayClick || $[10] !== t2) {
    t3 = <StyledModal isOpen={modalIsOpen} onRequestClose={onCloseModal} onAfterClose={onCloseModal} shouldCloseOnEsc={shouldCloseOnEsc} shouldCloseOnOverlayClick={shouldCloseOnOverlayClick} overlayClassName="ontario-overlay" bodyOpenClassName="ontario-modal-open" style={t2} aria={customAria} className={className} contentLabel={contentName}>{children}</StyledModal>;
    $[2] = children;
    $[3] = className;
    $[4] = contentName;
    $[5] = customAria;
    $[6] = modalIsOpen;
    $[7] = onCloseModal;
    $[8] = shouldCloseOnEsc;
    $[9] = shouldCloseOnOverlayClick;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default AppModal;